export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.svg?18df003f90a7f1313b98b23384ec4f1b";